import { ChangePasswordCard } from './change-password-card';
import { LanguageCard } from './language-card';
import { SessionsCard } from './sessions-card';

export function AccountSettingsPanel() {
  // Account + Notification preferences cards are hidden until their backend
  // flows ship (change-email/phone, persisted notification channels). For now
  // the only meaningful action on this tab is switching the UI language.
  return (
    <div className="flex flex-col gap-6">
      <LanguageCard />
    </div>
  );
}

export function SecuritySettingsPanel() {
  return (
    <div className="flex flex-col gap-6">
      <ChangePasswordCard />
      <SessionsCard />
    </div>
  );
}
